import {IRWN} from './IRWN';
import gsap from 'gsap';
import {ClockScene} from './ClockScene';
import {PlantScene} from './PlantScene';

const SceneSwitcher = {

  enabled: false,
  init: function(playcanvasApp) {
    this.btnPrev = {
      div: document.getElementById('path_btn_prev'),
      icon: document.getElementById('icon_btn_prev'),
      timer_disableClickready: null,
      pos_hide: '-20em',
      pos_show: '-7.7em',
      pos_active: '-7.7em',
    };
    this.btnNext = {
      div: document.getElementById('path_btn_next'),
      icon: document.getElementById('icon_btn_next'),
      timer_disableClickready: null,
      pos_hide: '-30em',
      pos_show: '-10em',
      pos_active: '-10em',
    };
  },

  //------------------------------------> SHOW
  show: function(currentSceneIndex) {
    // setup PREV
    const prevIndex = (currentSceneIndex > 0 ) ? currentSceneIndex-1 : 12;
    const prevSvg = `./tex/normalisedPlants/normalised_p${prevIndex}.svg`;
    SceneSwitcher.btnPrev.icon.dataset.src = prevSvg;
    SceneSwitcher.btnPrev.div.style.pointerEvents = 'all';
    SceneSwitcher.prev_goto(SceneSwitcher.btnPrev.pos_show, 1);
    SceneSwitcher.btnPrev.div.addEventListener('click', SceneSwitcher.loadPrevScene);

    // setup NEXT
    const nextIndex = (currentSceneIndex < 12) ? currentSceneIndex+1 : 0;
    const nextSvg = `./tex/normalisedPlants/normalised_p${nextIndex}.svg`;
    SceneSwitcher.btnNext.icon.dataset.src = nextSvg;
    SceneSwitcher.btnNext.div.style.pointerEvents = 'all';
    SceneSwitcher.next_goto(SceneSwitcher.btnNext.pos_show, 1);
    SceneSwitcher.btnNext.div.addEventListener('click', SceneSwitcher.loadNextScene);
  },

  hide: function() {
    SceneSwitcher.btnPrev.div.style.pointerEvents = 'none';
    SceneSwitcher.btnNext.div.style.pointerEvents = 'none';

    // timers
    if (SceneSwitcher.btnPrev.timer_disableClickReady != null) {
      SceneSwitcher.btnPrev.timer_disableClickReady.kill();
    }
    if (SceneSwitcher.btnNext.timer_disableClickReady != null) {
      SceneSwitcher.btnNext.timer_disableClickReady.kill();
    }

    SceneSwitcher.btnPrev.div.removeEventListener('click', SceneSwitcher.loadPrevScene);
    SceneSwitcher.btnNext.div.removeEventListener('click', SceneSwitcher.loadNextScene);

    SceneSwitcher.prev_goto(SceneSwitcher.btnPrev.pos_hide);
    SceneSwitcher.next_goto(SceneSwitcher.btnNext.pos_hide);
  },

  ////////////////////////////////////////////////////////////////
  //                                                          BTNS
  ////////////////////////////////////////////////////////////////
  prev_goto: function(value, duration = 1, onComplete = null) {
    gsap.killTweensOf('#switch_btn_prev', 'left');
    gsap.to('#switch_btn_prev', {left: value, duration, ease: 'expo.inOut', onComplete: onComplete});
  },

  next_goto: function(value, duration = 1, onComplete = null) {
    gsap.killTweensOf('#switch_btn_next', 'right');
    gsap.to('#switch_btn_next', {right: value, duration, ease: 'expo.inOut', onComplete: onComplete});
  },

  loadNextScene: function() {
    // analytics
    IRWN.analyticsReport('click_next_scene', 'next_scene');

    IRWN.currentSceneIndex++;
    IRWN.currentSceneIndex = IRWN.currentSceneIndex % 13;
    console.log('loading scene: ' + IRWN.currentSceneIndex);
    ClockScene.loadScene(IRWN.getPlantFromIndex(IRWN.currentSceneIndex));
    SceneSwitcher.hide();
    PlantScene.hideBreatheBth();
  },
  loadPrevScene: function() {
    // analytics
    IRWN.analyticsReport('click_previous_scene', 'prev_scene');

    IRWN.currentSceneIndex--;
    if (IRWN.currentSceneIndex < 0) IRWN.currentSceneIndex = 12;
    console.log('loading scene: ' + IRWN.currentSceneIndex);
    ClockScene.loadScene(IRWN.getPlantFromIndex(IRWN.currentSceneIndex));
    SceneSwitcher.hide();
  },
};

export {SceneSwitcher};
